import React, { useState, createContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { getAgenciesFullPermission } from 'reducers/PermissionsReducer';
import { useSelector } from 'react-redux';

const FilterContext = createContext('Some value');
const FilterProvider = FilterContext.Provider;
export const FilterConsumer = FilterContext.Consumer;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: 'calc(100vh - 54px)',
    paddingTop: theme.spacing(1),
  },
  panel: {
    height: '100%',
    overflow: 'auto',
    display: 'block',
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(3),
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

function SearchMenu(props) {
  const classes = useStyles();
  const { children } = props;
  const [tabValue, setTabValue] = useState('Unassigned');
  const [agencyList, setAgencyList] = useState([]);
  const Agencies = useSelector((state) => state.dictionary.Agencies);

  useEffect(() => {
    const canReadAgencies = getAgenciesFullPermission('cad', 'Alerts', 'Read');
    const agencyList = canReadAgencies.filter((AgencyID) =>
      Agencies.find((agency) => agency.AgencyID === AgencyID)
    );
    setAgencyList(agencyList);
    setTabValue(agencyList);
  }, [Agencies]);

  const tabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!agencyList.length) return '';

  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={tabValue}
        onChange={tabChange}
        className={classes.tabs}>
        <Tab label="Unassigned" value={'Unassigned'} />
        <Tab label="All" value={agencyList} />
        {agencyList?.map((agency) => (
          <Tab key={agency} label={agency} value={agency} />
        ))}
      </Tabs>
      <div className={classes.panel}>
        <FilterProvider value={typeof tabValue === 'object' ? tabValue : [tabValue]}>
          {children}
        </FilterProvider>
      </div>
    </div>
  );
}

export default SearchMenu;
